module.exports = __webpack_public_path__ + "static/media/screenshot(44).4a096cd9.jpg";